module.exports = __webpack_public_path__ + "static/img/zs003.0a4e1b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs003.jpg
// module id = C+L3
// module chunks = 13